// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"61cc4812","239":"60924273","488":"5a4cce60","550":"8af7781c","732":"247ba637"}[chunkId] + ".chunk.js";
};